import {
  CREATE_TEMPLATE_MAPPING,
  CREATE_TEMPLATE_MAPPING_SUCCESS,
  CREATE_TEMPLATE_MAPPING_ERROR,
  CREATE_TEMPLATE_MAPPING_EMPTY,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateTemplateMapping = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_TEMPLATE_MAPPING:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_TEMPLATE_MAPPING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_TEMPLATE_MAPPING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CREATE_TEMPLATE_MAPPING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateTemplateMapping;
